export default "__VITE_ASSET__BV60dlj4__"